import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import "../../../stili/tabelle.css";
import "../../../stili/popup.css";
import "../../../stili/tabs.css"
import convertDate from "../../../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../../../funzioni/nome_id.js"
import {
    convertiIdNoleggio,
    convertiValuta,
    convertiIdInventario,
    materialeDisponibile,
    analisiMateriale,
    sovrapposti,
    ordinaPerData,
    convertiTipoStorage,
    istruttori_disponibili, convertiColore, convertiTaglia, convertiIdEscursione
} from "../../../funzioni/funzioni_utili"
import TabellaLezioni from "../../../tabelle/lessons";
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faFileInvoice,faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import {noleggi_off,utenti_off} from "../../../offline/offline_costanti.js";
import status_lezione from "../../../funzioni/status_lezione";
import NoleggiTabella from "../../../tabelle/noleggi";
import StorageTabella from "../../../tabelle/storageTab";
import RiparazioniTabella from "../../../tabelle/riparazioniTab";
import AccessoriTab from "../../../tabelle/maglie";
import EscursioniCli from "../../../tabelle/escursioniCli";
/* global $ */
function StoricoConti() {
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
let pacchettiFatture={}
const traduzioni = {
    "Attrezzatura completa": "Full equipment",
    "Kite e barra": "Kite and bar",
    "Tavola twin tip": "Twin tip board",
    "Tavola surfino": "Surfboard",
    "Tavola foil": "Foil board",
    "Harness": "Harness",
    "Lycra e muta": "Lycra and wetsuit",
    "Caschetto e giubbotto": "Helmet and impact vest",
    "Twin tip - Surfino": "Twin tip - Surfboard",
    "Rossa": "Red",
    "Gialla": "Yellow",
    "Blu": "Blue",
    "Rosa": "Pink",
    "Bianca": "White",
    "Verde": "Green"
};
async function mostraPopupInfoConto(id,nome) {
  const allineamento="center"
  const lez_pac_gen = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
      filtri:{"getid":id},
    azione:"getBillItem",
      childs:["lessons","rentals","storages","accessories","repairs","excursioncustomers"]
  });
  const escursioni = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getExcursions",
            })
  const divGen= document.createElement("div");
     const mount = document.createElement("div");

    // Montiamo React nel contenitore
    const root = ReactDOM.createRoot(mount);
    const titolo1=document.createElement("h3")
    titolo1.innerText="Pacchetti lezioni"
    titolo1.style.fontFamily = "Poppins, sans-serif";
    titolo1.style.marginBottom="0px"
    root.render(<TabellaLezioni data={lez_pac_gen[0].lessons} />);
    divGen.appendChild(titolo1)
    divGen.appendChild(mount)
    const mount2 = document.createElement("div");

    // Montiamo React nel contenitore
    const root2 = ReactDOM.createRoot(mount2);
    root2.render(<NoleggiTabella datiNoll={lez_pac_gen[0].rentals} numeroConto={id} />);
    const titolo2=document.createElement("h3")
    titolo2.innerText="Pacchetti noleggi"
    titolo2.style.fontFamily = "Poppins, sans-serif";
    titolo2.style.marginBottom="0px"
    divGen.appendChild(titolo2)
    divGen.appendChild(mount2)
    const mount3 = document.createElement("div");
    const root3 = ReactDOM.createRoot(mount3);
    root3.render(<StorageTabella datiStor={lez_pac_gen[0].storages} numeroConto={id} />);
    const titolo3=document.createElement("h3")
    titolo3.innerText="Storage"
    titolo3.style.fontFamily = "Poppins, sans-serif";
    titolo3.style.marginBottom="0px"
    divGen.appendChild(titolo3)
    divGen.appendChild(mount3)
    const mount4 = document.createElement("div");
    const root4 = ReactDOM.createRoot(mount4);
    root4.render(<AccessoriTab maglietteDati={lez_pac_gen[0].accessories} numeroConto={id} />);
    const titolo4=document.createElement("h3")
    titolo4.innerText="Magliette"
    titolo4.style.fontFamily = "Poppins, sans-serif";
    titolo4.style.marginBottom="0px"
    divGen.appendChild(titolo4)
    divGen.appendChild(mount4)
    const mount5 = document.createElement("div");
    const root5 = ReactDOM.createRoot(mount5);
    root5.render(<RiparazioniTabella datiRip={lez_pac_gen[0].repairs} numeroConto={id} />);
    const titolo5=document.createElement("h3")
    titolo5.innerText="Riparazioni"
    titolo5.style.fontFamily = "Poppins, sans-serif";
    titolo5.style.marginBottom="0px"
    divGen.appendChild(titolo5)
    divGen.appendChild(mount5)
    const mount6 = document.createElement("div");
    const root6 = ReactDOM.createRoot(mount6);
    root6.render(<EscursioniCli escursioni={escursioni} dati={lez_pac_gen[0].excursioncustomers} numeroConto={id} />);
    const titolo6=document.createElement("h3")
    titolo6.innerText="Escursioni"
    titolo6.style.fontFamily = "Poppins, sans-serif";
    titolo6.style.marginBottom="0px"
    divGen.appendChild(titolo6)
    divGen.appendChild(mount6)

    return divGen
}

function DynamicLessonButton({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);

          const content = await mostraPopupInfoConto(
            cellInfo.data.billid,cellInfo.data.nome
          );
          $("#loadingOverlay").hide();  // Nasconde overlay
            setLoading(false);
          $("#popupConto").dxPopup("instance").option(
            "title",
            `Dettagli conto di ${cellInfo.data.nome}`
          );
          $("#popupConto").dxPopup("instance").option("contentTemplate", () => content);
          $("#popupConto").dxPopup("instance").show();
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faCircleInfo}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function DynamicLessonButton2({ cellInfo, }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    $("#loadingOverlay").show();
     setLoading(true);

          const lez_pac_gen = await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
     filtri:{"getid":cellInfo.data.billid},
    azione:"getBillItem",
      childs:["lessons","rentals","storages","accessories","repairs","excursioncustomers"]
  });
          const datiEsc = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            filtri:{"excursionsfrom":inizioP,"excursionsto":fineP},
            azione: "getExcursions",
            })
          const pacchetti=lez_pac_gen[0]
      let fatturabili={"lessons":[],"rentals":[],"storages":[],"accessories":[],"repairs":[],"excursioncustomers":[]}

      for (let lezione of pacchetti.lessons){
          if (lezione.invoiceid===0) fatturabili.lessons.push(lezione)
      }
      for (let noleggio of pacchetti.rentals){
          if (noleggio.invoiceid===0) fatturabili.rentals.push(noleggio)
      }
      for (let noleggio of pacchetti.storages){
          if (noleggio.invoiceid===0) fatturabili.storages.push(noleggio)
      }
      for (let noleggio of pacchetti.accessories){
          if (noleggio.invoiceid===0) fatturabili.accessories.push(noleggio)
      }
      for (let noleggio of pacchetti.repairs){
          if (noleggio.invoiceid===0) fatturabili.repairs.push(noleggio)
      }
      for (let noleggio of pacchetti.excursioncustomers){
          if (noleggio.invoiceid===0) fatturabili.excursioncustomers.push(noleggio)
      }
      const content=generaInterfacciaFattura(fatturabili,datiEsc)
        $("#fattura").dxPopup("instance").option(
            "title",
            `Fattura`
          );
          $("#fattura").dxPopup("instance").option("contentTemplate", () => content);
          $("#fattura").dxPopup("instance").show();
          $("#fattura").dxPopup("instance").option( "toolbarItems", [{
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        stylingMode: 'contained',
        text: 'Salva',
        onClick: async function () {
                let intestazioniR=$("#intestazione").dxDataGrid("instance").option("dataSource")[0]
                    delete intestazioniR["__KEY__"]
                    let totalePagato=0
                    let totale=0
                    let righe=$("#righe").dxDataGrid("instance").option("dataSource")
                    for (let riga of righe){
                        totale+=riga.invoicerownettotvalue
                        totalePagato+=riga.pagato

                    }
                    intestazioniR["invoicedate"]=DateTime.fromISO(intestazioniR["invoicedate"]).toFormat("yyyyMMdd")
                    intestazioniR["invoicenetvalue"]=totale
                    intestazioniR["invoicegrossvalue"]=totale
                    intestazioniR["invoiceadvance"]=totalePagato
                    intestazioniR["invoicetopay"]=totale-totalePagato

                    let richiestaFattura=await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:intestazioniR,
                        azione:'setInvoice'})
                    const idFattura=richiestaFattura.invoiceid
                    let richiestaRiga
                    for (let riga of righe){
                        delete riga.__KEY__
                        riga["invoiceid"]=idFattura
                        richiestaRiga=await funzione_collegamento({
                            userid: getUserId(),
                            token: getToken(),
                            logout_on_error: true,
                            valori:riga,
                            azione:'setInvoiceRow'})
                    }
                    const fatturaRich=await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        filtri:{getid:idFattura},
                        azione:'generateInvoice'})
                    if (!$("#bottoneSalva").dxCheckBox("instance").option("value")) {
                         richiestaFattura=await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                             delId:idFattura,
                        azione:'delInvoice'})
                    }
                    else{
                        const mappaFunzioni={1:"setLesson",2:"setRental",3:"setStorage",4:"setAccessoryItem",5:"setRepair",6:"setExcursionCust"}
                        let rich=null
                        for (let azioneServ in pacchettiFatture){
                            for (let id of pacchettiFatture[azioneServ]){
                                rich=await funzione_collegamento({
                               userid: getUserId(),
                                token: getToken(),
                                logout_on_error: true,
                                 setId:id,
                                valori:{invoiceid:idFattura},
                                azione:mappaFunzioni[azioneServ]})
                            }
                        }
                    }
                    const baseURL = "https://jckite.mogaverocompany.co.ke";
                    const fileURL = fatturaRich.pdffilename?fatturaRich.pdffilename.startsWith("http")
                        ? fatturaRich.pdffilename
                        : `${baseURL}${fatturaRich.pdffilename.startsWith("/") ? "" : "/"}${fatturaRich.pdffilename}`:"";
                     window.open(fileURL, "_blank");
            }
      },
    }, {
      widget: 'dxButton',
      toolbar: 'bottom',
      location: 'after',
      options: {
        text: 'Chiudi',
        stylingMode: 'outlined',
        type: 'normal',
        onClick() {
          $("#fattura").dxPopup("instance").hide();
        },
      },
    }],)
          $("#loadingOverlay").hide();
            setLoading(false);
  };

  return (
    <BounceIconButton
      icon={loading ? faSpinner : faFileInvoice}
       className={loading ? 'spin-icon' : ''}
      color="#46dbf2"
      onClick={loading ? null : handleClick}
    />
  );
}
function generaInterfacciaFattura(dati,escursioni){
    const divGen=document.createElement("div")
    const allineamento="center"
    const divSalva=document.createElement("div")
    divSalva.id="bottoneSalva"
    divSalva.style.marginTop="10px"
    divGen.appendChild(divSalva)
    const divIntest=document.createElement("div")
    divIntest.id="intestazione"
    const divRighe=document.createElement("div")
    divRighe.id="righe"
    divGen.appendChild(divIntest)
    divGen.appendChild(divRighe)
    let righe=[]
    let quantita={}
    let giaMesse=[]
    pacchettiFatture={}
    for (let lezione of dati.lessons){
        if (!(lezione.lessonpacket in quantita)) quantita[lezione.lessonpacket]={"costo":0,"quantita":0,"pagato":0}
        quantita[lezione.lessonpacket]["quantita"]+=1
        quantita[lezione.lessonpacket]["costo"]+=(lezione.lessoncost * (1 - (lezione.lessondiscount || 0) / 100))
        quantita[lezione.lessonpacket]["pagato"]+=lezione.lessonadvance
        if (!(1 in pacchettiFatture))pacchettiFatture[1]=[]
        pacchettiFatture[1].push(lezione.lessonid)
    }
    for (let lezione of dati.lessons){
        if (!giaMesse.includes(lezione.lessonpacket))
        righe.push({"invoicerowdescr":`${lezione.lessonpacket}H kitesurfing lesson package`,"pagato":quantita[lezione.lessonpacket]["pagato"],"invoicerowcurrency":1,"invoicerowquant":quantita[lezione.lessonpacket]["quantita"],"invoicerownetunitvalue":quantita[lezione.lessonpacket]["costo"]/quantita[lezione.lessonpacket]["quantita"],"invoicerownettotvalue":quantita[lezione.lessonpacket]["costo"],"invoicerowgrosstotvalue":quantita[lezione.lessonpacket]["costo"]})
        giaMesse.push(lezione.lessonpacket)
    }
    quantita={}
    for (let noleggio of dati.rentals){
        let giorniNol=[]
        for (let singolo of noleggio.inventories){
            if (!giorniNol.includes(DateTime.fromFormat(singolo.rentinvlinkfrom,"yyyyMMddHHmm").toFormat("yyyyMMdd"))) giorniNol.push(DateTime.fromFormat(singolo.rentinvlinkfrom,"yyyyMMddHHmm").toFormat("yyyyMMdd"))

        }
        let giorniTot=0
        if (giorniNol.length>0)giorniTot=giorniNol.length
        else {
            giorniTot=DateTime.fromFormat(noleggio.rentalto,"yyyyMMdd").diff(DateTime.fromFormat(noleggio.rentalfrom,"yyyyMMdd")).as('days')
        }
        if (!(2 in pacchettiFatture))pacchettiFatture[2]=[]
        pacchettiFatture[2].push(noleggio.rentalid)
        if (!(`${giorniTot} ${noleggio.rentaltype}` in quantita)) quantita[`${giorniTot} ${noleggio.rentaltype}`]={"costo":0,"quantita":0,"durata":0,"pagato":0}
        quantita[`${giorniTot} ${noleggio.rentaltype}`]["quantita"]+=1
        quantita[`${giorniTot} ${noleggio.rentaltype}`]["pagato"]+=noleggio.rentaladvance
        quantita[`${giorniTot} ${noleggio.rentaltype}`]["costo"]+=(noleggio.rentalcost * (1 - (noleggio.rentaldiscount || 0) / 100))
    }
    for (let durata in quantita){
        const [a, b] = durata.split(" ").map(Number);
        righe.push({"invoicerowdescr":`${a} ${a===1?"day":"days"} ${traduzioni[convertiIdNoleggio(b)]} rental`,"pagato":quantita[durata]["pagato"],"invoicerowcurrency":1,"invoicerowquant":quantita[durata]["quantita"],"invoicerownetunitvalue":quantita[durata]["costo"]/quantita[durata]["quantita"],"invoicerownettotvalue":quantita[durata]["costo"],"invoicerowgrosstotvalue":quantita[durata]["costo"]})
    }
    quantita={}
    for (let noleggio of dati.storages){
        let giorniTot=DateTime.fromFormat(noleggio.storageto,"yyyyMMdd").diff(DateTime.fromFormat(noleggio.storagefrom,"yyyyMMdd")).as('days')
        if (!(3 in pacchettiFatture))pacchettiFatture[3]=[]
        pacchettiFatture[3].push(noleggio.storageid)
        if (!(`${giorniTot} ${noleggio.storagetype}` in quantita)) quantita[`${giorniTot} ${noleggio.storagetype}`]={"costo":0,"quantita":0,"durata":0,"pagato":0}
        quantita[`${giorniTot} ${noleggio.storagetype}`]["quantita"]+=1
        quantita[`${giorniTot} ${noleggio.storagetype}`]["costo"]+=(noleggio.storagecost * (1 - (noleggio.storagediscount || 0) / 100))
        quantita[`${giorniTot} ${noleggio.storagetype}`]["pagato"]+=noleggio.storageadvance
    }
    for (let durata in quantita){
        const [a, b] = durata.split(" ").map(Number);
        righe.push({"invoicerowdescr":`${a} ${a===1?"day":"days"} ${convertiTipoStorage(b)}`,"pagato":quantita[durata]["pagato"],"invoicerowcurrency":1,"invoicerowquant":quantita[durata]["quantita"],"invoicerownetunitvalue":quantita[durata]["costo"]/quantita[durata]["quantita"],"invoicerownettotvalue":quantita[durata]["costo"],"invoicerowgrosstotvalue":quantita[durata]["costo"]})
    }
    quantita={}
    for (let noleggio of dati.accessories){
        if (!(4 in pacchettiFatture))pacchettiFatture[4]=[]
        pacchettiFatture[4].push(noleggio.accessoryid)
        if (!(`${noleggio.accessorycolor} ${noleggio.accessorysize} ${noleggio.accessorysoldcurrency}` in quantita)) quantita[`${noleggio.accessorycolor} ${noleggio.accessorysize} ${noleggio.accessorysoldcurrency}`]={"costo":0,"quantita":0,"durata":0,"pagato":0}
        quantita[`${noleggio.accessorycolor} ${noleggio.accessorysize} ${noleggio.accessorysoldcurrency}`]["quantita"]+=1
        quantita[`${noleggio.accessorycolor} ${noleggio.accessorysize} ${noleggio.accessorysoldcurrency}`]["costo"]+=noleggio.accessorysoldprice
        quantita[`${noleggio.accessorycolor} ${noleggio.accessorysize} ${noleggio.accessorysoldcurrency}`]["pagato"]+=noleggio.accessorysoldadvance
    }
    for (let durata in quantita){
        const [a, b,c] = durata.split(" ").map(Number);
        righe.push({"invoicerowdescr":`T-Shirt ${convertiTaglia(b)} ${traduzioni[convertiColore(a)]}`,"pagato":quantita[durata]["pagato"],"invoicerowcurrency":c,"invoicerowquant":quantita[durata]["quantita"],"invoicerownetunitvalue":quantita[durata]["costo"]/quantita[durata]["quantita"],"invoicerownettotvalue":quantita[durata]["costo"],"invoicerowgrosstotvalue":quantita[durata]["costo"]})
    }
    for (let riparazione of dati.repairs){
        if (!(5 in pacchettiFatture))pacchettiFatture[5]=[]
        pacchettiFatture[5].push(riparazione.repairid)
        righe.push({"invoicerowdescr":`Repair ${riparazione.repairkitename}`,"pagato":riparazione.repairadvance,"invoicerowcurrency":riparazione.repaircostcurrency,"invoicerowquant":1,"invoicerownetunitvalue":riparazione.repaircost,"invoicerownettotvalue":riparazione.repaircost,"invoicerowgrosstotvalue":riparazione.repaircost})
    }
    quantita={}
    for (let noleggio of dati.excursioncustomers){
        if (!(`${noleggio.excursionid}` in quantita)) quantita[`${noleggio.excursionid}`]={"costo":0,"quantita":0,"tipo":0,"pagato":0}
        if (!(6 in pacchettiFatture))pacchettiFatture[6]=[]
        pacchettiFatture[6].push(noleggio.excursioncustomerid)
        for (let escursione of escursioni){
            if (escursione.excursionid===noleggio.excursionid){
                quantita[`${noleggio.excursionid}`]["quantita"]+=1
                quantita[`${noleggio.excursionid}`]["costo"]+=noleggio.excursioncustomerpaid
                quantita[`${noleggio.excursionid}`]["tipo"]=escursione.excursiontype
                quantita[`${noleggio.excursionid}`]["pagato"]=noleggio.excursioncustomeradvance
            }
        }
    }
    for (let durata in quantita){
        const tipo=parseInt(quantita[durata]["tipo"])
        righe.push({"invoicerowdescr":`Excursion ${convertiIdEscursione(tipo)}`,"invoicerowcurrency":1,"pagato":quantita[durata]["pagato"],"invoicerowquant":quantita[durata]["quantita"],"invoicerownetunitvalue":quantita[durata]["costo"]/quantita[durata]["quantita"],"invoicerownettotvalue":quantita[durata]["costo"],"invoicerowgrosstotvalue":quantita[durata]["costo"]})
    }
    setTimeout(()=> {
        $("#bottoneSalva").dxCheckBox({
            text:"Salva fattura",
            value:false,
        })
        $("#intestazione").dxDataGrid({
            dataSource:[],
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica intestazione",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
            columns:[
                 { dataField: "invoicecustomer", alignment:allineamento,caption: "Nome Fattura",hidingPriority:9},
          {
            dataField: "invoicedate",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg_int").length===0) {
                $('<div id="val_reg_int"></div>').appendTo(cellElement)
            }
            $("#val_reg_int").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
            { dataField: "invoiceaddress", alignment:allineamento,caption: "Indirizzo cliente",hidingPriority:2,
        },
            { dataField: "invoicecontacts", alignment:allineamento,caption: "contatti cliente",hidingPriority:3,
        },
        { dataField: "invoicenotes", alignment:allineamento,caption: "Note fattura",hidingPriority:1,
        },
            { dataField: "invoicenumber", alignment:allineamento,caption: "Numero fattura",hidingPriority:4,
        },
            {dataField:"invoicecurrency",caption:"Valuta",
            visible:false,
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            let cont1=0
              let dati_ut=[]
              while (convertiValuta(cont1)){
                dati_ut.push({id:cont1,name:convertiValuta(cont1)})
                  cont1+=1
              }
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }},


            ],
        })
        $("#righe").dxDataGrid({
            dataSource:righe,
            editing: {
                mode: "popup",
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                useIcons: true,
                popup: {
                    title: "Modifica intestazione",
                    showTitle: true,
                    width: "80%",
                    height: "auto",
                    maxHeight: "90%",
                }
            },
            columns:[
                {"dataField":"invoicerowdescr","caption":"Descrizione", hidingPriority:5},
                {"dataField":"invoicerowquant",caption:"Quantità",hidingPriority:2,
                editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_quantita_righe").length===0) {
                $('<div id="val_quantita_righe"></div>').appendTo(cellElement)
            }
            $("#val_quantita_righe").dxNumberBox({value:cellInfo.value,minValue:0,onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_unitario").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                { dataField: "invoicerowcurrency",visible:false, caption: "Valuta",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta2").length===0) {
                $('<div id="val_valuta2"></div>').appendTo(cellElement)
            }
            let cont1=0
              let dati_ut=[]
              while (convertiValuta(cont1)){
                dati_ut.push({id:cont1,name:convertiValuta(cont1)})
                  cont1+=1
              }
            $("#val_valuta2").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_netto").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_unitario").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
                    $("#val_gross").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)

            }})
          },
        },
                {"dataField":"invoicerownetunitvalue","caption":"Costo unitario",hidingPriority:3,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_unitario").length===0) {
                $('<div id="val_unitario"></div>').appendTo(cellElement)
            }
            $("#val_unitario").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
                    $("#val_netto").dxNumberBox("instance").option("value",$("#val_quantita_righe").dxNumberBox("instance").option("value")*e.value)
            }})
          }
                },
                {"dataField":"invoicerownettotvalue","caption":"Costo netto totale",hidingPriority:4,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_netto").length===0) {
                $('<div id="val_netto"></div>').appendTo(cellElement)
            }
            $("#val_netto").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

                {"dataField":"pagato","caption":"Pagato",hidingPriority:1,
                cellTemplate: (cellElement, cellInfo) => {
                  if (cellInfo.value!==0){
                    const root = ReactDOM.createRoot(cellElement.get(0));
                    console.log(cellInfo)
                    root.render(
                <div style={{ fontFamily: "Poppins, sans-serif" }}>
                    {cellInfo.value.toFixed(2)}{convertiValuta(cellInfo.data.invoicerowcurrency)}
                </div>
            );
          }},
                    editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_pag_in").length===0) {
                $('<div id="val_pag_in"></div>').appendTo(cellElement)
            }
            $("#val_pag_in").dxNumberBox({value:cellInfo.value,minValue:0,format:`#0.##${convertiValuta(cellInfo.data.invoicerowcurrency)}`, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            }})
          }
                },

            ],
            columnAutoWidth: true,
        columnHidingEnabled: true,
        })

    },0)
    return divGen

}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStoricoConti() {
    const allineamento="center"
    useEffect(() => {
        const fetchStorages = async () => {
            $("#gridContainerSpese").addClass("grid-container-hidden")
            $("#loadingOverlay").show()
            const datiTipi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBillItems",
            })
            const datiSotto = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getRegistrySubtypes",
            })
            const dati = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                filtri:{"transactionsfrom":inizioP,"transactionsto":fineP},
                azione: "getBillItems",
            })
            let conti=[]
            let categorie=[]
           let sottocategorie=[]
           for (let categoria of datiTipi){
            if (categoria.registrytypecategory===1){
                categorie=[...categorie,{ID:categoria.registrytypeid,name:categoria.registrytypedescr}]
            }
           }
            for (let categoria of datiSotto){
            if (categoria.registrytypecategory===1){
                sottocategorie=[...sottocategorie,{ID:categoria.registrysubtypeid,name:categoria.registrysubtypedescr,idCat:categoria.registrytypeid}]
            }
           }
            for (let conto of dati){
                conti=[...conti,{nome:conto.billcustomer,billid:conto.billid,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                costo:conto.billtotalamount,pagato:conto.billpaidamount,note:conto.billnotes
                }]
            }

            $("#gridContainerSpese").dxDataGrid({

          dataSource: conti,
        columns: [
             { dataField: "nome", alignment:allineamento,caption: "Nome conto",hidingPriority:5},
          {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
            editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value, onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 7,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },


          { dataField: "costo", alignment:allineamento,caption: "Importo conto", hidingPriority:3,calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.costo)val=rowData.costo
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`},
  },
            { dataField: "pagato", alignment:allineamento,caption: "Importo pagato", hidingPriority:3,calculateDisplayValue: function(rowData) {
          let val=0
          if (rowData.pagato)val=rowData.pagato
    return  `${val.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`},
  },
        { dataField: "note", alignment:allineamento,caption: "Note conto",hidingPriority:5,
        },

          {
            type: "buttons",
            minWidth:140,
            buttons: [
                {
  hint: "Dettagli conto",
  icon: "none",
  template: function (cellElement, cellInfo) {
    const root = ReactDOM.createRoot(cellElement.get(0));
    root.render(<DynamicLessonButton cellInfo={cellInfo} />);
  },
},
                {
  hint: "Scarica Fattura",
  icon: "none",
  template: function (cellElement, cellInfo) {
    const root = ReactDOM.createRoot(cellElement.get(0));
    root.render(<DynamicLessonButton2 cellInfo={cellInfo} />);
  },
},
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
            ],
          },
          ],
          showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica conto",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form: {
  colCount: 1,  // Tutti gli elementi a tutta larghezza
  items: [
    {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "nome","data","note",
                ],
              },
  ],
}

        },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },

        onInitNewRow: function (e) {
              e.data.data=DateTime.now().toISO()
        },
        onRowInserting: async function (e) {
              let dati_n={'billcustomer':e.data.nome,"billdate":convertDate(DateTime.fromISO(e.data.data)),"billnotes":e.data.note,};
            let richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setBillItem'})
                if (richiesta) {
                window.location.reload()

                }

        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerSpese"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            let lux=null
            if (!(e.data.data instanceof Date))
            lux=DateTime.fromISO(e.data.data)
            else
            lux=DateTime.fromJSDate(e.data.data)
            let dati_n={'billcustomer':e.data.nome,"billdate":convertDate(DateTime.fromISO(e.data.data)),"billnotes":e.data.note,};
            let richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.billid,
                valori:dati_n,
                azione:'setBillItem'})
                if (richiesta) {
                const message = `Spesa modificata con successo`;
                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerSpese',

                        },}, "success", 500);
                }
            },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.billid,
                azione:'delBillItem',
                return_data:false})
            if (richiesta) {
                const message = `Conto eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerSpese',

                },}, "success", 500);}
        },
        onRowPrepared: function (e) {
            setTimeout(() => {
                $("#gridContainerSpese").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
            if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));

            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo);
            if ((!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01)) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }

        },
          })
          $("#fattura").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
 showCloseButton:true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollFattura" style="height: 100%;"></div>');
    $("#customScrollFattura").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });
    $("#popupConto").dxPopup({
    width: "90%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    showCloseButton:true,

    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollLista" style="height: 100%;"></div>');
    $("#customScrollLista").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });

        }
        fetchStorages()
    },[])
return (<div id="gridContainerSpese" ></div>)
}

return (<div>
        <TabellaStoricoConti/>
        <div id="fattura"/>
    <div id="popupConto"/>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}

export default StoricoConti